import { IconProps } from "interfaces/icons";

const CleaningIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 24;

	if (size) {
		height = size;
	}

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={height}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color || "#0A0E27"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
			<polyline points="9 22 9 12 15 12 15 22" />
		</svg>
	);
};

export default CleaningIcon;
